/**
 * Montecito Commercial Painting Schema
 * Enhanced LocalBusiness schema for commercial painting in Montecito
 */

export function getMontecitoCommercialSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "HousePainter",
    "name": "Danis Painting Co. - Montecito Commercial Painting",
    "description": "Premier luxury commercial painting contractor serving Montecito businesses: Coast Village Road boutiques, Upper Village shops, high-end restaurants, professional offices, and estate management properties. Premium finishes and discreet service for Montecito's finest commercial properties.",
    "url": "https://danispainting.net/service/commercial-painting/montecito",
    "telephone": "+1-805-403-8727",
    "email": "danispainting@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "133 E De La Guerra St, #267",
      "addressLocality": "Santa Barbara",
      "addressRegion": "CA",
      "postalCode": "93101",
      "addressCountry": "US"
    },
    "geo": [
      {
        "@type": "GeoCoordinates",
        "latitude": 34.4208,
        "longitude": -119.6382,
        "name": "Coast Village Road - Montecito"
      },
      {
        "@type": "GeoCoordinates",
        "latitude": 34.4356,
        "longitude": -119.6195,
        "name": "Upper Village - Montecito"
      },
      {
        "@type": "GeoCoordinates",
        "latitude": 34.4187,
        "longitude": -119.6289,
        "name": "Montecito Village"
      }
    ],
    "areaServed": {
      "@type": "City",
      "name": "Montecito",
      "containedInPlace": {
        "@type": "AdministrativeArea",
        "name": "California"
      }
    },
    "serviceType": "Commercial Painting",
    "priceRange": "$$$-$$$$",
    "paymentAccepted": "Cash, Check, Credit Card, Financing Available",
    "openingHours": "Mo-Su 07:00-19:00",
    "image": "https://d2xsxph8kpxj0f.cloudfront.net/310519663313033271/eUvaV5v4nLRJmrJ6AKc5ww/gallery-5_d36da2e9_a4c69cb6.webp",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Montecito Commercial Painting Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Coast Village Road Boutique Painting",
            "description": "Luxury retail and boutique painting for Coast Village Road businesses with premium finishes"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Upper Village Commercial Painting",
            "description": "Professional office and retail painting for Upper Village Montecito properties"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "High-End Restaurant Painting",
            "description": "Fine dining restaurant painting with meticulous attention to detail and premium materials"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Estate Management Property Painting",
            "description": "Commercial painting for estate management offices, guest houses, and luxury property facilities"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Professional Office Painting",
            "description": "Discreet, high-quality painting for law offices, medical practices, and professional services in Montecito"
          }
        }
      ]
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "127"
    },
    "review": [
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Robert H."
        },
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5"
        },
        "reviewBody": "Danis Painting exceeded our expectations on our estate's exterior refresh. Their attention to detail and respect for our property was exceptional."
      },
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Susan K."
        },
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5"
        },
        "reviewBody": "Outstanding quality and craftsmanship! They did extensive drywall repair and painting in our home. The results were flawless. True professionals in every sense."
      }
    ]
  };
}
